import React from "react";
import {connect} from "react-redux";
import SVG from "react-inlinesvg";
import closeicon from "../../../assets/close.svg";
import $ from "jquery";
import {updateUser, fetchUserRoles, setUserToInActive} from "../../../actions/userActions";
import {objectToFormData} from "../../../utils/api";

class UserModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            roles: {},
            userRole: '',
            user_name: '',
            disable: true,
            user_role_id: false,
            user_role: {
                id: false,
                role: false,
                active: false,
            },
            role_check: false
        };
    }

    componentDidMount() {
        let data = this.props.data;
        const state = Object.assign({}, this.state);
        state.user_role_id = data.role !== null ? data.role : "";
        state.user_role.role = data.role !== null ? data.role : "";
        state.user_role.id = data.role_id !== null ? data.role_id : false;
        state.user_role.active = data.active !== null ? data.active === 1 ? 1 : 0 : this.state.user_role.active;
        state.user_name = data.full_name !== null ? data.full_name : "";
        this.setState({
            ...state,
            user_role_id: state.user_role_id
        })
        $("html, body").animate({scrollTop: 0}, 300);
    }

    onUpdate = (e, uid) => {
        let { user_role, user_name } = this.state
        let obj = {}
        user_role.active = user_role.active === 1 ? 1 : 0;
        obj.user_name = user_name;
        obj.role_id = parseInt(user_role.id);
        obj.active = user_role.active.toString();
        let data = objectToFormData(obj);
        this.props.dispatch(updateUser(data, uid));
        this.props.toggleModal(false)
    }

    handleRadioChange = (e) => {
        this.setState({
            disable: false,
            user_role: {
                ...this.state.user_role,
                id: e.target.value,
                role: e.target.id
            }
        })
    }
    checkChange = (e) => {
        let checked = e.target.checked === false ? 0 : 1;
        this.setState({
            disable: false,
            user_role: {
                ...this.state.user_role,
                active: checked
            }
        })
    }
    handleChange = (e) => {
        this.setState({
            disable: false,
            user_name: e.target.value
        })

    }

    render() {
        let {data, roles} = this.props;
        return (
            <div className="admin-user-modal">
                <div className="admin-user-modal-content">
                    <div className="closeBtn" onClick={() => this.props.toggleModal(false)}>
                        <SVG src={closeicon}/>
                    </div>
                    <div className="admin-user-modal-header">
                        <h1>Edit User</h1>
                    </div>
                    <div className="admin-input-container">
                        <div className="admin-user-input-container">
                            <div className="admin-label-container">
                                <label htmlFor="userName">Name</label>
                                <label>Department</label>
                                <label htmlFor="userRegion">Region</label>
                                <div>Permissions</div>
                                <label>Email</label>
                                <div className="status-label">Status</div>
                            </div>
                            <div className="admin-inputs">
                                <input type="text" className="userInputs" name="userName" id="userName"
                                       value={this.state.user_name}
                                       onChange={this.handleChange}/>
                                <p>{data.department !== null ? data.department : "Department"}</p>
                                <p>{data.office !== null ? data.office : "New York"}</p>
                                <div className="admin-radio-container">
                                    <ul>
                                        {roles.map((r, key) => {
                                            return (<li key={r.label}>
                                                <input type="radio" id={r.label} name="permissions"
                                                       checked={this.state.user_role.role === r.label} value={r.id}
                                                       onChange={this.handleRadioChange}/>
                                                <label htmlFor={r.label}>{r.value}</label>
                                            </li>)
                                        })}
                                    </ul>
                                </div>
                                <p>{data.email !== null ? data.email : ""}</p>
                                <div className="status-container">
                                    <label className="status">
                                        <input type="checkbox" name="status" id="status" value={this.props.data.active}
                                               checked={this.state.user_role.active} onChange={this.checkChange}/>
                                        {/*todo need to add data to see when status is active or inactive*/}
                                        <span className="slider round"></span>
                                    </label>
                                    <span style={this.state.user_role.active === 1 ? {display: 'inline'} : {}}>{this.state.user_role.active ? 'Active' : "Inactive"}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="admin-modal-footer">
                        <span className="button--transparent admin-cancel-btn" onClick={() => this.props.toggleModal(false)}>cancel</span>
                        <button className={`admin-update-btn button button--black ${this.state.disable ? 'disable' : ''}`} disabled={this.state.disabled} onClick={(e) => this.onUpdate(e,data.id)}>Save changes</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(null)(UserModal);